/**
  * @function evaluate - evaluate docRipperRipTitleBehavior
  */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, evaluateSource) => {
  const {
    importField,
    importFormType
  } = content;
  const [{
    title: formTypeTitle
  }] = Object.values(importFormType);
  const [{
    title: fieldTitle
  }] = Object.values(importField);
  const pages = (await evaluateSource({
    type: 'getCacheValueBehavior',
    name: 'docRipper/matches/pages'
  })) || [];
  return pages.length ? `Rip ${pages.length} pages with linked '${fieldTitle}' values and associate them with select '${formTypeTitle}' assets.` : 'No matches found. Refresh to try a different Field selection or PDF.';
};
export default {
  evaluate
};